//eslint-disable-next-line
import axios, { $asyncGet, $asyncPost } from '../common.js';

/**
 * 获取所有订单
 * /v3/merchant/Market/sale/order/MerchantListSaleReport
 */
export function orderMerchantListSaleReport() {
  return $asyncGet(`v3/merchant/Market/sale/order/MerchantListSaleReport?merchant_id=${localStorage.getItem("merchant_id")}`);
}